
import { Vue, Component, Prop } from 'vue-property-decorator';
import { CarrierFilterType } from '@/features/common/raw';

@Component
export default class FilterItem extends Vue {
  @Prop({ default: () => [] }) service!: CarrierFilterType;

  get showItem(): boolean {
    return this.service.show;
  }

  set showItem(value: boolean) {
    this.$emit('toggleService', { value, name: this.service.name });
  }

  toggleLevel(value: boolean, levelValue: string): void {
    this.$emit('toggleLevel', { value, serviceName: this.service.name, levelValue });
  }
}
